import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var ChatAsk = function ChatAsk(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24571 2H20.7307C21.9808 2 23 3.08769 23 4.42164V12.2897C23 13.5555 22.4999 14.9193 20.9157 14.9193C20.8792 14.9224 20.5979 14.9219 20.357 14.921L20.0066 14.9193V17.9006C20.0066 18.3975 19.5018 18.8944 18.9998 18.8944C17.9998 18.8944 17.4998 18.3975 16.4998 16.9069L14.9998 14.9193H6.24571C4.99561 14.9193 3.90602 13.8008 3.97645 12.2844V4.42164C3.99997 2.99379 4.99561 2 6.24571 2ZM20.8497 4.90931C20.8497 4.40174 20.4287 3.98758 19.9127 3.98758H6.93691C6.42091 3.98758 5.99997 4.40174 5.99997 4.90931V12.01C5.99997 12.5175 6.42091 12.9317 6.93691 12.9317H15.62C15.783 12.9317 15.9369 12.9984 16.041 13.1188L17.8883 15.9131V13.4749C17.8883 13.1721 18.1291 12.9317 18.4368 12.9317H18.4727C18.7003 12.9317 19.9298 12.9324 19.9436 12.9317C20.4395 12.9082 20.8497 12.4981 20.8497 12.0056V4.90931Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 8.45964C10.9999 9.28292 10.3284 9.95032 9.49995 9.95032C8.67152 9.95032 7.99996 9.28292 7.99996 8.45964C7.99996 7.63636 8.67152 6.96895 9.49995 6.96895C10.3284 6.96895 10.9999 7.63636 10.9999 8.45964Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 8.45964C14.9999 9.28292 14.3283 9.95032 13.4999 9.95032C12.6715 9.95032 11.9999 9.28292 11.9999 8.45964C11.9999 7.63636 12.6715 6.96895 13.4999 6.96895C14.3283 6.96895 14.9999 7.63636 14.9999 8.45964Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 8.45964C18.9999 9.28292 18.3283 9.95032 17.4999 9.95032C16.6715 9.95032 15.9999 9.28292 15.9999 8.45964C15.9999 7.63636 16.6715 6.96895 17.4999 6.96895C18.3283 6.96895 18.9999 7.63636 18.9999 8.45964Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 17.0311C14.9999 16.4527 14.5762 16.0373 13.9999 16.0373H9.1587C8.15871 16.0373 7.99996 16.5342 7.49996 17.0311L5.99997 19.0187V17.528C6.06294 15.7336 4.40603 16.0371 3.90603 16.037C3.41014 16.0135 2.99999 15.6034 2.99999 15.1108V6.09933C2.99999 4.6086 1 4.60879 1 6.09948V15.6629C1 16.9286 1.83832 17.9217 2.99999 18.0248C3.04737 18.029 3.55768 18.0239 3.8318 18.0211C3.92041 18.0202 3.98434 18.0196 3.99998 18.0196V21.0062C3.99998 21.542 4.49793 22 4.99997 22C5.26606 22 5.49997 22 5.99997 21.5031L8.99995 18.0248L13.9011 18.0202C13.9336 18.0233 13.9666 18.0249 13.9999 18.0249C14.5762 18.0249 14.9999 17.6095 14.9999 17.0311Z",
    fill: color
  }));
};

export { ChatAsk };
